import { render } from "./Direct_Purchases.vue?vue&type=template&id=0262ffb4&scoped=true"
import script from "./Direct_Purchases.vue?vue&type=script&lang=js"
export * from "./Direct_Purchases.vue?vue&type=script&lang=js"

import "./Direct_Purchases.vue?vue&type=style&index=0&id=0262ffb4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0262ffb4"]])

export default __exports__